import {
  bathroomPackages,
  facadeMaterials,
  floorMaterials,
  houseModels,
  kitchenPackages,
  layouts,
  productOptions,
  roofMaterials,
  wallPackages,
  windowMaterials
} from "./data";
import type { HouseConfiguration, PriceBreakdown } from "./types";

const priceOf = <T extends { id: string; priceDelta: number }>(items: T[], id: string) =>
  items.find((item) => item.id === id)?.priceDelta ?? 0;

export function calculatePrice(configuration: HouseConfiguration): PriceBreakdown {
  const model = houseModels.find((item) => item.id === configuration.modelId) ?? houseModels[0];
  const base = model.basePrice;
  const area = (configuration.areaM2 - model.baseAreaM2) * 10_800;
  const layout = priceOf(layouts, configuration.layoutId);
  const exterior =
    priceOf(facadeMaterials, configuration.facadeMaterialId) +
    priceOf(roofMaterials, configuration.roofMaterialId) +
    priceOf(windowMaterials, configuration.windowColorId) +
    (configuration.terrace ? 74_000 : 0) +
    (configuration.carport ? 128_000 : 0);
  const interior =
    priceOf(floorMaterials, configuration.floorMaterialId) +
    priceOf(wallPackages, configuration.wallPackageId) +
    priceOf(kitchenPackages, configuration.kitchenPackageId) +
    priceOf(bathroomPackages, configuration.bathroomPackageId);
  const options = configuration.options.reduce(
    (total, id) => total + (productOptions.find((item) => item.id === id)?.price ?? 0),
    0
  );

  return {
    base,
    area,
    layout,
    exterior,
    interior,
    options,
    total: base + area + layout + exterior + interior + options
  };
}
